// "¿TE VAS SIN GUARDAR?" — el aviso antes de cambiar de módulo.
//
// Lissette, 2026-09-24: *"cuando se esté creando un correo masivo poder
// guardarlo en draft, que el sistema pregunte si le damos click en otro lado
// sin querer"*. Un clic en el menú desmontaba Correo Masivo y con él el
// asunto, el cuerpo y los destinatarios marcados, sin decir nada.
//
// Cómo funciona: la pantalla que tiene algo sin guardar pone UNA guardia
// (`ponerGuardiaDeSalida`). El cambio de módulo de deskte-full.jsx pregunta
// aquí antes de moverse, y la guardia decide —normalmente preguntándole a la
// persona— si se puede salir. Sin guardia puesta, el cambio es inmediato,
// exactamente como antes: ninguna otra pantalla nota nada.
//
// Una sola guardia y no una lista: solo hay un módulo abierto a la vez.
// Vive aparte, sin nada de React, para que deskte-full.jsx y la pantalla
// hablen sin pasarse props a través de medio archivo.

let guardia = null;

/**
 * Pone la guardia. `fn(destino)` devuelve una promesa: true = se puede salir.
 * Devuelve la función que la quita — solo si sigue siendo ESTA, para que una
 * pantalla que se desmonta tarde no le quite la suya a la que llegó después.
 */
export function ponerGuardiaDeSalida(fn) {
  guardia = fn;
  return () => { if (guardia === fn) guardia = null; };
}

export function hayGuardiaDeSalida() {
  return !!guardia;
}

/**
 * ¿Se puede ir a `destino`? Si la guardia falla por dentro, la respuesta es
 * NO: quedarse en la pantalla con el trabajo intacto se arregla con otro clic;
 * salir y perderlo no se arregla.
 */
export async function pedirPermisoParaSalir(destino) {
  if (!guardia) return true;
  try {
    return !!(await guardia(destino));
  } catch (err) {
    console.error('[salida-sin-guardar] la guardia fallo; se queda en la pantalla', err?.message || err);
    return false;
  }
}
